import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { formatTimestamp } from "../../lib";

const TEMPLATE: Record<string, (actor: string, user: string) => string> = {
  invited: (actor, user) => `${actor} invited ${user}`,
  accepted: (_actor, user) => `${user} accepted the invite`,
  updated: (actor, user) => `${actor} updated ${user}`,
  deleted: (actor, user) => `${actor} deleted ${user}`,
};

function describeActivity(row: {
  event_type: string | null;
  actor_name: string | null;
  user_name: string | null;
}): string {
  const actor = row.actor_name || "Someone";
  const user = row.user_name || "an unknown user";
  const template = row.event_type ? TEMPLATE[row.event_type] : null;
  if (!template) return `${actor} changed ${user}`;
  return template(actor, user);
}

// returns: array of latest 10 user_activity rows, each with
//   { ...row, user_name, actor_name, f_created_at, f_activity }
export const recent_user_activity: Query<Ctx> = async ({ sb }, _params) => {
  const { data } = await sb
    .from("v_recent_user_activity")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(10);
  if (!data) return [];

  return data.map((row: any) => ({
    ...row,
    f_created_at: formatTimestamp(row.created_at),
    f_activity: describeActivity(row),
  }));
};
